import { render, staticRenderFns } from "./DexHeaderDropdownGroupItem.vue?vue&type=template&id=2ed12fbd&scoped=true&"
import script from "./DexHeaderDropdownGroupItem.vue?vue&type=script&lang=js&"
export * from "./DexHeaderDropdownGroupItem.vue?vue&type=script&lang=js&"
import style0 from "./DexHeaderDropdownGroupItem.vue?vue&type=style&index=0&id=2ed12fbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed12fbd",
  null
  
)

export default component.exports